function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Header from 'js/containers/organisms/Header';
import Footer from 'js/containers/organisms/Footer';
import { constructPopulationString } from './helpers';
import * as countryActions from '../../store/reducers/country/actions';
import * as plotActions from '../../store/reducers/country/plot/data/actions';
import * as dataActions from '../../store/reducers/country/plot/currentState/actions';
import * as userAuthActions from '../../store/reducers/auth/user/actions';
import * as navActions from '../../store/reducers/nav/header/actions';
import Dashboard from '../../containers/templates/Dashboard';
var actions = [countryActions, dataActions, plotActions, userAuthActions, navActions];

function mapDispatchToProps(dispatch) {
  var _Map;

  var creators = (_Map = Map()).merge.apply(_Map, actions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch: dispatch
  };
}

function mapStateToProps(state, ownProps) {
  return {
    country: state.country,
    user: state.user
  };
}

var CountryPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CountryPage, _React$Component);

  function CountryPage(props) {
    var _this;

    _classCallCheck(this, CountryPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CountryPage).call(this, props));

    _this.shouldComponentUpdate = function (nextProps) {
      if (_this.props.user.role === undefined) return true;
      if (_this.props.country.ni === undefined) return true; // Temporary

      if (_this.props.country.ni !== nextProps.country.ni) return true; // Temporary

      return false;
    };

    _this.componentDidMount = function () {
      var pathname = _this.props.location.pathname;

      _this.props.actions.setBackground('transparent');

      _this.props.actions.setColor('white');

      var countryID = pathname.split('/')[2];

      _this.setState({
        countryID: countryID
      });

      var fetchData = _this.props.actions.fetchData;
      fetchData(countryID, pathname, _this.props.actions.saveCountryData, _this.props.history);
    };

    _this.render = function () {
      var country = _this.props.country.ni;
      return React.createElement("div", null, React.createElement(Header, _this.props), React.createElement("div", {
        className: "data-page-wrapper",
        id: "data-page-wrapper"
      }, React.createElement("div", {
        id: "about",
        className: "container-fluid data-page__about-country"
      }, React.createElement("div", {
        className: "data-page__about-country__background"
      }), React.createElement("div", {
        className: "data-page__about-country-info-wrapper"
      }, React.createElement("h1", {
        id: "country-name-title",
        className: "data-page__about-country__name-title"
      }, country ? country.description.name : ''), React.createElement("p", {
        id: "country-population-subtitle",
        className: "data-page__about-country__population-subtitle"
      }, country ? "Population: ".concat(constructPopulationString(country.description.population)) : ''))), React.createElement("div", {
        className: "data-page__content-section"
      }, country ? React.createElement(Dashboard, {
        countryID: _this.state.countryID,
        plots: country.plots
      }) : '')), React.createElement(Footer, _this.props));
    };

    _this.state = {};
    return _this;
  }

  return CountryPage;
}(React.Component);

CountryPage.propTypes = {
  actions: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  country: PropTypes.object.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(CountryPage);